import PropTypes from 'prop-types';
import React, { useRef, useEffect } from 'react';
import Button from 'creatella-react-components/lib/Button';
import Input from 'creatella-react-components/lib/Input';
import isNumeric from 'validator/lib/isNumeric';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css'; // optional

import './LoginScreen.scss';

OTPScreen.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    isProcessing: PropTypes.bool.isRequired,
    formState: PropTypes.object.isRequired,
    setFormState: PropTypes.func.isRequired,
    resendOTP: PropTypes.func.isRequired,
    counter: PropTypes.number.isRequired,
    content: PropTypes.any.isRequired,
    userNumber: PropTypes.string,
    page: PropTypes.object
};

function OTPScreen({ onSubmit, isProcessing, formState, setFormState, resendOTP, counter, content, userNumber, page }) {
    const onChangeField = (field) => (e) => {
        const value = e.target.value;

        if (isNumeric(value)) {
            setFormState(prevState => ({
                ...prevState,
                [field]: value
            }));

            switch (field) {
                case 'otp1':
                    if (value !== '') {
                        formRef.current.otp2.focus();
                    }

                    break;
                case 'otp2':
                    if (value !== '') {
                        formRef.current.otp3.focus();
                    }

                    break;
                case 'otp3':
                    if (value !== '') {
                        formRef.current.otp4.focus();
                    }

                    break;
                case 'otp4':
                    if (value !== '') {
                        formRef.current.subBtn.focus();
                    }

                    break;

                default:
                    break;
            }
        }

        if (!isNumeric(value) && value !== '') {
            setFormState(prevState => ({
                ...prevState,
                [field]: ''
            }));
        }
    };

    const submitForm = (e) => {
        // prevent form submit
        e.preventDefault();
        const otp = String(formState.otp1 + formState.otp2 + formState.otp3 + formState.otp4);

        formRef.current.otp1.focus();

        onSubmit({ otp });
    };

    const formRef = useRef(null);

    useEffect(() => {
        formRef.current.otp1.focus();
    }, []);

    const handleKeyDown = (e, name) => {
        if (e.keyCode === 39) {
            // go next

            switch (name) {
                case 'otp1':

                    formRef.current.otp2.focus();

                    break;

                case 'otp2':
                    formRef.current.otp3.focus();

                    break;

                case 'otp3':
                    formRef.current.otp4.focus();

                    break;

                case 'otp4':
                    formRef.current.subBtn.focus();

                    break;

                default:
                    break;
            }
        }

        if (e.keyCode === 37) {
            // go prev
            switch (name) {
                case 'otp2':
                    formRef.current.otp1.focus();

                    break;

                case 'otp3':
                    formRef.current.otp2.focus();

                    break;

                case 'otp4':
                    formRef.current.otp3.focus();

                    break;
                case 'subBtn':
                    formRef.current.otp4.focus();

                    break;

                default:
                    break;
            }
        }

        if (e.keyCode === 8) {
            // press backspace
            switch (name) {
                case 'otp2':
                    if (formState.otp2 === '') {
                        formRef.current.otp1.focus();
                    } else {
                        setFormState(prevState => ({
                            ...prevState,
                            otp2: ''
                        }));
                    }

                    break;

                case 'otp3':
                    if (formState.otp3 === '') {
                        formRef.current.otp2.focus();
                    } else {
                        setFormState(prevState => ({
                            ...prevState,
                            otp3: ''
                        }));
                    }

                    break;

                case 'otp4':
                    if (formState.otp4 === '') {
                        formRef.current.otp3.focus();
                    } else {
                        setFormState(prevState => ({
                            ...prevState,
                            otp4: ''
                        }));
                    }

                    break;

                default:
                    break;
            }
        }
    };

    return (
        <div className='loginScreen'>
            <form
                autoComplete='new-password'
                ref={formRef}
                className='loginForm otpForm'
                onSubmit={submitForm}>
                <img src={page.logo} alt='Paper Trader' className='loginForm__logo' />
                <div className='loginForm__description loginForm__description--otp'>Please enter the One-Time Password sent to +{userNumber}</div>
                <div className='otpForm-box'>
                    <Input
                        autoComplete='current-password'
                        name='otp1'
                        maxLength='1'
                        type={'text'}
                        value={formState.otp1.value}
                        placeholder=''
                        className='otpForm-box__input'
                        onKeyDown={e => handleKeyDown(e, 'otp1')}
                        onChange={onChangeField('otp1')} />
                    <Input
                        autoComplete='current-password'
                        name='otp2'
                        maxLength='1'
                        type={'text'}
                        value={formState.otp2.value}
                        placeholder=''
                        className='otpForm-box__input'
                        onKeyDown={e => handleKeyDown(e, 'otp2')}
                        onChange={onChangeField('otp2')} />
                    <Input
                        autoComplete='current-password'
                        name='otp3'
                        maxLength='1'
                        type={'text'}
                        value={formState.otp3.value}
                        placeholder=''
                        className='otpForm-box__input'
                        onKeyDown={e => handleKeyDown(e, 'otp3')}
                        onChange={onChangeField('otp3')} />
                    <Input
                        autoComplete='current-password'
                        name='otp4'
                        maxLength='1'
                        type={'text'}
                        value={formState.otp4.value}
                        placeholder=''
                        className='otpForm-box__input'
                        onKeyDown={e => handleKeyDown(e, 'otp4')}
                        onChange={onChangeField('otp4')} />
                </div>
                <Button
                    isDisabled={isProcessing ? false : !formState.otp1.length || !formState.otp2.length || !formState.otp3.length || !formState.otp4.length}
                    isProcessing={isProcessing}>
                    <button className='loginForm__submit otpSubmit' name='subBtn'
                        onKeyDown={e => handleKeyDown(e, 'subBtn')}

                        type='submit'>
                        Validate
                    </button>
                </Button>
                <div className='otp-resend'>
                    { counter !== 60 && counter !== 0 ? <span className='otp-resend__counter'>{counter}</span>
                        : <button className='otp-resend__btn' onClick={resendOTP} type='button'>
                            Resend OTP
                        </button>
                    }
                    <Tippy allowHTML={true} placement='top-end' className='pt-tooltip'
                        content={content}>
                        <span className='otp-resend__help'>I need help</span>
                    </Tippy>
                </div>

            </form>
        </div>
    );
}

export default OTPScreen;
